import React from 'react'
import PropTypes from 'prop-types'
import LazyImage from '~hooks/lazy-image'
import useTranslate from '~hooks/useTranslate/useTranslate'
import Bonus from '~molecules/bonus-box/template-three'
import { TrackingKeys } from '~constants/tracking-api'
import { imagePrettyUrl } from '~helpers/getters'
import { getAltText } from '~helpers/image';

import styles from './header-operator-bannner.module.scss'
import { trackerLinkActive } from "~helpers/tracker.mjs";

const HeaderOperatorBaner = ({
  operator,
  logo,
  buttonType = 'primary',
  buttonSize = 'm',
  template,
  moduleName = TrackingKeys?.OPERATORBANNER,
  clickedElement = 'header_operator_banner',
  width = 64,
  height = 64,
  modulePosition,
  itemPosition
}) => {
  let main

  const statusText = useTranslate(
    operator?.status,
    operator?.status?.replace('_', ' ')
  )

  if (['coming_soon', 'inactive'].includes(operator?.status)) {
    main = (
      <p className={styles[operator?.status] || ''}>
        {statusText}
      </p>
    )
  } else if (
    operator?.status === 'active' ||
    operator?.status === 'not_recommended'
  ) {
    main = (
      <>
        <Bonus
          moduleName={moduleName}
          clickedElement={clickedElement}
          ctaBtn
          item={operator}
          tracker="main"
          pageTemplate={template}
          buttonType={buttonType}
          buttonSize={buttonSize}
          modulePosition={modulePosition}
          itemPosition={itemPosition}
          customClass={styles.headerBannerBonus || ''}
        />
      </>
    )
  }
  
  return (
    trackerLinkActive(operator) && (
      <div className={`${styles.operatorBanner}`}>
        {logo?.filename && (
          <LazyImage
            loading="eager"
            src={imagePrettyUrl(logo?.filename, width, height)}
            width={width}
            height={height}
            alt={getAltText(logo, operator?.name)}
          />
        )}
        {main}
      </div>
    )
  )
}

HeaderOperatorBaner.propTypes = {
  operator: PropTypes.shape({
    name: PropTypes.string,
    type: PropTypes.string,
    template: PropTypes.string,
    links: PropTypes.shape({
      main: PropTypes.string
    }),
    status: PropTypes.string
  }),
  logo: PropTypes.shape({
    filename: PropTypes.string
  }),
  template: PropTypes.string,
  buttonType: PropTypes.string,
  buttonSize: PropTypes.string,
  moduleName: PropTypes.string,
  clickedElement: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  modulePosition: PropTypes.number,
  itemPosition: PropTypes.number
}

export default HeaderOperatorBaner
